import { useState } from 'react'

import type { Survey, SurveySelection, SurveyFilterOption } from 'app/common/types/surveys'
import { api } from 'app/api'
import {
  GET_SURVEY,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/surveys/id/get'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import type { HandleModalDisplayed } from 'app/common/ui-next/plain-modal'
import { SurveyValuesModal } from './SurveyValuesModal'

import styles from './SurveyScopeValues.module.scss'

type Props = {
  survey: Survey
  field: 'cities' | 'districts' | 'schools'
  header: string
  fallback: string
}

export const SurveyScopeValues = ({ survey, field, header, fallback }: Props) => {
  const values = survey[field]
  const [complete, setComplete] = useState<SurveySelection | undefined>()
  const [districts, setDistricts] = useState<Array<SurveyFilterOption>>(
    survey.districts?.items || [],
  )
  const [pending, setPending] = useState(false)

  const handleOpen = async (toggle: HandleModalDisplayed) => {
    if (!values) return
    if (!complete && values.items.length < values.count) {
      setPending(true)
      try {
        const details = await api.request(GET_SURVEY, {
          params: {
            surveyId: survey.id,
            grouping: 'day',
            cityIds: [],
            districtIds: [],
            schoolTypes: [],
            schoolIds: [],
          },
          convertions: { convertParams, convertResult },
          error: 'Не удалось получить полный список значений опроса',
        })
        if (!details) return
        setComplete(details.survey[field])
        setDistricts(details.survey.districts?.items || [])
      } finally {
        setPending(false)
      }
    }
    toggle(true)
  }

  if (!values?.count) return <>{fallback}</>
  if (values.count === 1) return <>{values.items[0]?.title || fallback}</>
  return (
    <SurveyValuesModal
      header={header}
      items={(complete || values).items}
      districts={field === 'schools' ? districts : []}
    >
      {(toggle) => (
        <PlainButtonAsLink
          linkClassName={pending ? undefined : styles.valueLink}
          disabled={pending}
          onClick={() => handleOpen(toggle)}
          ariaLabel={`${header}: ${values.count}`}
        >
          {pending ? 'Загрузка…' : values.count}
        </PlainButtonAsLink>
      )}
    </SurveyValuesModal>
  )
}
